<template>
  <!-- 审批拒绝 -->
  <div class="reject-clue">
    <el-form
      ref="formRef"
      :model="formData"
      label-position="top"
      style="padding-top: 20px;"
    >
      <!-- 将该线索 -->
      <el-form-item
        label="将该线索"
        prop="handleType"
        :rules="[
          { required: true, message: '请选择处理方式', trigger: 'change' }
        ]"
      >
        <el-radio-group v-model="formData.handleType" class="handle-radio-group">
          <el-radio label="incubate">转入公海孵化池</el-radio>
          <el-radio label="push">转入公海推进池</el-radio>
          <el-radio label="transfer">转长期维护</el-radio>
          <el-radio label="changeFollower">换人跟进</el-radio>
          <el-radio label="continueFollow">继续跟进</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 选择跟进人 -->
      <el-form-item
        v-if="formData.handleType === 'changeFollower'"
        label="新跟进人"
        prop="follower"
        :rules="[
          { required: true, message: '请选择新跟进人', trigger: 'change' }
        ]"
      >
        <el-select
          v-model="formData.follower"
          placeholder="请选择"
          filterable
          size="small"
          class="form-select"
        >
          <el-option label="杨一一" value="yangyiyi"></el-option>
          <el-option label="杨姗姗" value="yangshanshan"></el-option>
          <el-option label="李某某" value="limoumou"></el-option>
          <el-option label="王某某" value="wangmoumou"></el-option>
        </el-select>
      </el-form-item> 

      <!-- 填写拒绝原因 -->
      <el-form-item
        label="填写拒绝原因"
        prop="rejectReason"
        :rules="[
          { required: true, message: '请填写拒绝原因', trigger: 'blur' }
        ]"
      >
        <el-input
          v-model="formData.rejectReason"
          type="textarea"
          :rows="4"
          placeholder="请输入..."
        />
      </el-form-item>
    </el-form>
  </div>
</template>
 
<script>
  export default {
    name: 'RejectClueApply',
    data() {
      return {
        formData: {
          handleType: '', // 处理方式
          rejectReason: '' // 拒绝原因
        },
        submitting: false // 防止重复提交
      }
    },
    methods: {
      /**
       * 提交拒绝表单
       * @returns {Promise<boolean>} 提交是否成功
       */
      async submitHandle() {
        // 防止重复提交
        if (this.submitting) {
          return false
        }

        let isFinish = false
        
        try {
          // 表单验证
          const valid = await this.$refs.formRef.validate()
          
          if (!valid) {
            return false
          }

          // 开始提交
          this.submitting = true

          // 构建请求参数
          const params = {
            clueId: this.currentClueInfo.id || this.currentClueInfo.doctorId,
            handleType: this.formData.handleType,
            rejectReason: this.formData.rejectReason
          }

          // TODO: 替换为实际的 API 调用
          // const response = await rejectClueApplication(params)
          // if (response.code === 200) {
          //   this.$message.success('拒绝成功')
          //   isFinish = true
          // } else {
          //   this.$message.error(response.message || '拒绝失败')
          //   isFinish = false
          // }

          // 模拟 API 调用（待替换）
          isFinish = await new Promise((resolve) => {
            setTimeout(() => {
              this.$message.success('拒绝成功')
              resolve(true)
            }, 1000)
          })

          return isFinish
        } catch (error) {
          console.error('拒绝提交失败：', error)
          isFinish = false
          return false
        } finally {
          // 重置提交状态
          this.submitting = false
        }
      },

      /**
       * 重置表单
       */
      resetForm() {
        this.$refs.formRef.resetFields()
      }
    },
    props: {
      currentClueInfo: {
        type: Object,
        default: () => ({})
      }
    }
  }
 
</script>

<style scoped lang='less'>
.reject-clue {
  padding: 0 20px;
  .handle-radio-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;

    /deep/ .el-radio {
      margin-right: 0;
      height: auto;
      line-height: 1.5;
    }
  }
}
</style>